<script>

    import { chargeStore } from '../stores'

    import ModalContainer from '../$components/modal.container.svelte'

    import ChargesDownload from './component.charges.download.svelte'
    import ChargesUpload from './component.charges.upload.svelte'
    import ChargesComponent from './component.charges.svelte'
    import ChargeComponent from './component.charge.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Cargos" subtitle="Consulta y gestión de cargos" />
        <ChargesComponent all={true} />
    </div>
</View>

<ModalContainer id="charges_download_modal" title="Descargar cargos" >
    <ChargesDownload />
</ModalContainer>

<ModalContainer id="charges_upload_modal" title="Subir cargos" >
    <ChargesUpload />
</ModalContainer>

<ModalContainer id="charge_modal" title="Detalles" >
    <ChargeComponent charge={$chargeStore} />
</ModalContainer>
